import { Record } from 'immutable';
import { construct, fields } from '../helpers/LinkMapper';

const ReservationStation = new Record({
    nlc: null,
    name: null,
});

Object.assign(ReservationStation.prototype, {
    getStationName() {
        return this.name;
    },
});

ReservationStation.fromJSON = function(json) {
    return construct(ReservationStation, json, {
        nlc: fields.string,
        name: fields.string,
    });
};

export default ReservationStation;
